import Tokens from '../Tokens';

const name = 'star';


const contents = `
<circle fill="${Tokens.iconBadgeFillColor}" cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M31 50.839L19.433 56.92l2.209-12.879-9.357-9.122 12.932-1.879L31 21.321l5.783 11.719 12.932 1.879-9.357 9.122 2.209 12.879z"/>
`;


/** @type {import ('./types').Icon} */
const icon = {
  name,
  contents,
};

export default icon;
